import { booleanSchema, numberSchema, stringSchema, objectSchema } from '@/schemas'

export const threadListInputSchema = objectSchema({
  perPage: numberSchema.optional(),
  read: booleanSchema.optional(),
  search: stringSchema.optional(),
})
